module.exports = __webpack_public_path__ + "img/90.3c02942.png";